import React from "react";
import {NavLink, Redirect, Route, Switch} from "react-router-dom";

import {Login} from './components/Login';
import {Recover} from './components/Recover';
import {Signup} from './components/Signup';
import {Container} from "semantic-ui-react";
import {Header as MyHeader} from "../../components";

export const Users = (props) => {

    return (
        <React.Fragment>
            <MyHeader/>
            <Container>
                <Switch>
                    <Route exact path='/users/login/:return'>
                        <Login/>
                    </Route>
                    <Route exact path='/users/recover' component={Recover}/>
                    <Route exact path='/users/signup' component={Signup}/>
                    <Redirect to={'/users/login/0'} />
                </Switch>
            </Container>
        </React.Fragment>
    );
}